import { render } from "./CircleQuestionIcon.vue?vue&type=template&id=7bc2db08&scoped=true"
import script from "./CircleQuestionIcon.vue?vue&type=script&lang=js"
export * from "./CircleQuestionIcon.vue?vue&type=script&lang=js"

import "./CircleQuestionIcon.vue?vue&type=style&index=0&id=7bc2db08&scoped=true&lang=css"

import exportComponent from "C:\\Users\\GlavTV\\Documents\\GitHub\\octagon_uz\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bc2db08"]])

export default __exports__